import type { DemoPersona } from "@peer-start/platform-contracts";

export type ManagedUserRole = "teacher" | "manager" | "mentor";

export const mentorTitle = "Coach";

const storageKey = "peer-start-user-roles";

const emailById: Record<string, string> = {
  noor: "noor.devries@delinde.nl",
  samira: "samira.elamrani@delinde.nl",
  daan: "daan.smit@delinde.nl",
  kevin: "kevin.jansen@delinde.nl",
  marieke: "marieke.bos@delinde.nl",
  femke: "femke.kuipers@delinde.nl",
  "lina-waterkant": "lina.vermeer@obswaterkant.nl",
  "joris-waterkant": "joris.meijer@obswaterkant.nl",
};

const lastLoginById: Record<string, string> = {
  noor: "12 okt 2026",
  samira: "12 okt 2026",
  daan: "11 okt 2026",
  kevin: "8 okt 2026",
  marieke: "12 okt 2026",
  femke: "12 okt 2026",
  "lina-waterkant": "10 okt 2026",
  "joris-waterkant": "9 okt 2026",
};

export function userEmail(persona: DemoPersona): string {
  return emailById[persona.id] ?? `${persona.id}@peer-start.demo`;
}

export function userLastLogin(persona: DemoPersona): string {
  return lastLoginById[persona.id] ?? "Nog niet ingelogd";
}

export function isMentor(persona: { kind: string; title?: string }): boolean {
  return persona.kind === "supervisor" && (persona.title === mentorTitle || persona.title === "Mentor");
}

export function personaRoleKey(persona: {
  kind: "employee" | "supervisor" | "admin";
  title?: string;
}): "employee" | "supervisor" | "admin" | "mentor" {
  return isMentor(persona) ? "mentor" : persona.kind;
}

export function workspaceHome(persona: {
  kind: "employee" | "supervisor" | "admin";
  title?: string;
}): string {
  if (persona.kind === "employee") return "/me";
  if (persona.kind === "admin") return "/admin/situation-cards";
  return isMentor(persona) ? "/manage/mentees" : "/manage/chat";
}

export function defaultUserRole(persona: DemoPersona): ManagedUserRole {
  if (isMentor(persona)) return "mentor";
  return persona.kind === "supervisor" ? "manager" : "teacher";
}

export function loadUserRoles(): Record<string, ManagedUserRole> {
  if (typeof localStorage === "undefined") return {};
  const stored = localStorage.getItem(storageKey);
  if (!stored) return {};
  try {
    return JSON.parse(stored) as Record<string, ManagedUserRole>;
  } catch {
    return {};
  }
}

export function saveUserRoles(roles: Record<string, ManagedUserRole>): void {
  localStorage.setItem(storageKey, JSON.stringify(roles));
}
